import { History, ListOrdered, Newspaper, Radio } from "lucide-react";
import { FormBadges } from "./TeamBits";

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "2-digit" }) : "");

export function RecentForm({ team, side }) {
  return (
    <div className="surface-raised p-6" data-testid={`recent-form-${side}`}>
      <div className="flex items-center justify-between mb-4">
        <div className="label">Forma · {team.name}</div>
        <FormBadges form={team.form} size="md" />
      </div>
      <div className="space-y-1.5">
        {(team.recent || []).map((r) => (
          <div key={r.event_id || `${r.date}-${r.opponent}`} className="grid grid-cols-[auto_1fr_auto] items-center gap-3 text-sm border border-[#27272A] px-3 py-2">
            <span className={`w-5 h-5 grid place-items-center text-[10px] font-black text-black ${r.result === "W" ? "bg-[#39FF14]" : r.result === "D" ? "bg-[#A1A1AA]" : "bg-[#FF3B30]"}`}>
              {{ W: "V", D: "N", L: "P" }[r.result] || "?"}
            </span>
            <span className="truncate">{r.home_away === "@" ? "@ " : "vs "}{r.opponent}</span>
            <span className="mono font-bold">{r.score}</span>
          </div>
        ))}
        {!team.recent?.length && <div className="text-sm text-[#A1A1AA]">Dati non disponibili.</div>}
      </div>
    </div>
  );
}

export function H2HCard({ h2h = [] }) {
  return (
    <div className="surface-raised p-6" data-testid="h2h-card">
      <div className="label mb-5 flex items-center gap-2"><History size={12} strokeWidth={1.5} /> Scontri Diretti</div>
      <div className="space-y-2">
        {h2h.map((h) => (
          <div key={h.event_id || h.date} className="grid grid-cols-[auto_1fr_auto_1fr] items-center gap-3 border border-[#27272A] px-3 py-2 text-sm">
            <span className="mono text-[10px] text-[#71717A] w-16">{fmtDate(h.date)}</span>
            <span className="truncate text-right">{h.home}</span>
            <span className="mono font-black">{h.home_score}-{h.away_score}</span>
            <span className="truncate">{h.away}</span>
          </div>
        ))}
        {!h2h.length && <div className="text-sm text-[#A1A1AA]">Nessun precedente recente disponibile.</div>}
      </div>
    </div>
  );
}

export function StandingsCard({ standings = [] }) {
  if (!standings.length) return null;
  const focusIdx = standings.map((s, i) => (s.focus ? i : -1)).filter((i) => i >= 0);
  const rows = standings.filter((_, i) => focusIdx.some((f) => Math.abs(f - i) <= 1));
  return (
    <div className="surface-raised p-6" data-testid="standings-card">
      <div className="label mb-4 flex items-center gap-2"><ListOrdered size={12} strokeWidth={1.5} /> Classifica</div>
      <div className="space-y-1">
        {rows.map((s) => (
          <div key={s.team_id} className={`grid grid-cols-[28px_1fr_auto_auto] gap-3 px-3 py-1.5 text-sm ${s.focus ? "bg-[#39FF14]/10 border-l-2 border-[#39FF14]" : "text-[#A1A1AA]"}`}>
            <span className="mono">{s.rank}</span>
            <span className="truncate">{s.team}</span>
            <span className="mono text-[11px]">{s.goal_diff}</span>
            <span className="mono font-black w-8 text-right">{s.points}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function LiveEvents({ events = [] }) {
  if (!events.length) return null;
  return (
    <div className="surface-raised p-6" data-testid="live-events">
      <div className="label mb-4 flex items-center gap-2"><Radio size={12} strokeWidth={1.5} /> Cronaca</div>
      <div className="space-y-2 max-h-80 overflow-y-auto pr-1">
        {[...events].reverse().map((e) => (
          <div key={`${e.minute}-${e.type}-${e.text}`} className="flex gap-3 text-sm">
            <span className="mono text-[#39FF14] w-12 shrink-0">{e.minute}</span>
            <span className="text-[#A1A1AA]"><b className="text-white">{e.type}</b> {e.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function NewsCard({ news = [] }) {
  if (!news.length) return null;
  return (
    <div className="surface-raised p-6" data-testid="news-card">
      <div className="label mb-4 flex items-center gap-2"><Newspaper size={12} strokeWidth={1.5} /> Notizie sulle squadre</div>
      <div className="space-y-3">
        {news.map((n) => (
          <div key={`${n.published}-${n.headline}`} className="text-sm border-l border-[#27272A] pl-3">
            <div className="font-medium leading-snug">{n.headline}</div>
            <div className="mono text-[10px] text-[#71717A] mt-0.5">{fmtDate(n.published)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
